import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from 'actions'
import SelectSyaryougaisunWidth from 'components/site/select_syaryougaisun_width'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectSyaryougaisunWidthStart: state.searchFormCondition.selectSyaryougaisunWidthStart,
  selectSyaryougaisunWidthFinish: state.searchFormCondition.selectSyaryougaisunWidthFinish,
})

const SyaryougaisunWidthContainer = connect(mapStateToProps, mapDispatchToProps)(SelectSyaryougaisunWidth)

export default SyaryougaisunWidthContainer
